/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * required_item object
 * @export
 * @interface GetLoyaltyStoresCorporationIdOffersRequiredItem
 */
export interface GetLoyaltyStoresCorporationIdOffersRequiredItem {
    /**
     * quantity integer
     * @type {number}
     * @memberof GetLoyaltyStoresCorporationIdOffersRequiredItem
     */
    quantity: number;
    /**
     * type_id integer
     * @type {number}
     * @memberof GetLoyaltyStoresCorporationIdOffersRequiredItem
     */
    typeId: number;
}

/**
 * Check if a given object implements the GetLoyaltyStoresCorporationIdOffersRequiredItem interface.
 */
export function instanceOfGetLoyaltyStoresCorporationIdOffersRequiredItem(value: object): value is GetLoyaltyStoresCorporationIdOffersRequiredItem {
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    return true;
}

export function GetLoyaltyStoresCorporationIdOffersRequiredItemFromJSON(json: any): GetLoyaltyStoresCorporationIdOffersRequiredItem {
    return GetLoyaltyStoresCorporationIdOffersRequiredItemFromJSONTyped(json, false);
}

export function GetLoyaltyStoresCorporationIdOffersRequiredItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLoyaltyStoresCorporationIdOffersRequiredItem {
    if (json == null) {
        return json;
    }
    return {
        
        'quantity': json['quantity'],
        'typeId': json['type_id'],
    };
}

export function GetLoyaltyStoresCorporationIdOffersRequiredItemToJSON(json: any): GetLoyaltyStoresCorporationIdOffersRequiredItem {
    return GetLoyaltyStoresCorporationIdOffersRequiredItemToJSONTyped(json, false);
}

export function GetLoyaltyStoresCorporationIdOffersRequiredItemToJSONTyped(value?: GetLoyaltyStoresCorporationIdOffersRequiredItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quantity': value['quantity'],
        'type_id': value['typeId'],
    };
}

